/**
* @file 资源管理-车辆资源备份
* */
<template>
  <div id="vehicleBackup">
    <custom-table ref="customTable" has-organization="true" maxHeight="480" :customOptions="customOptions" :columns="columns"  excel-type="BackupsVehicle">
      <div slot="search-bottom" style="margin-top:10px;color:#999">说明：车辆数据被删除后，将在这里产生一条备份记录</div>
      <template slot-scope="{ item, row }">
        <div v-if="item.prop === 'vehiclePhoto'" style="display: flex; align-items: center">
          <img v-if="row.vehiclePhoto" :src="mixinQiniuImg(row.vehiclePhoto, 95, 40)" />
        </div>
        <template v-else-if="item.prop === 'updated'">{{
          row.updated | filterTime
        }}</template>
        <div v-else-if="item.prop === 'licenseNo'" class="avatar-name">
          <span 
            v-if="row.licenseNo"
            :style="getPlateStyle(row.licenseNo)"
            @dblclick="$utils.dblclickCopy"
          >{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
        </div>
        <div v-else-if="item.prop === 'driverName'">
          <span v-if="row.driverName">{{ row.driverName }}</span>
          <span v-if="!row.driverName" style="color: #999">无</span>
        </div>
        <template v-else-if="item.prop === 'vehicleSeat'">
          {{ row.vehicleSeat }}座
        </template>
        <template v-else-if="item.prop === 'operation'">
          <el-button type="primary" @click="compileClick(row)">查看</el-button>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
      <template slot="importColumn" slot-scope="{ item, row }">
        <div v-if="
            item.prop === 'vehiclePhoto' ||
            item.prop === 'roadTransportCertificate' ||
            item.prop === 'drivingLicenseFront' ||
            item.prop === 'drivingLicenseBack'
          ">
          <img class="column-img" v-if="row[item.prop]" :src="mixinQiniuImg(row[item.prop])" />
          <div class="no-upload" v-else>未上传</div>
        </div>
        <template v-else-if="item.prop === 'vehicleSeat'">
          {{ row.vehicleSeat }}座
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <el-drawer :visible.sync="detailShow" :close-on-click-modal="false">
      <vehicleFormBackup :id="detailId" />
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: "vehicleBackup",
  components: {
    vehicleFormBackup: () => import("./vehicleFormBackup.vue"),
  },
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "api/v1/manage/backups/vehicle",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "input",
            field: "licenseNo",
            name: "车辆号牌",
            value: "",
          },
          {
            type: "input",
            field: "vehicleNo",
            name: "车辆编号",
            value: "",
          },
          {
            type: "input",
            field: "vehicleResponsible",
            name: "车辆责任人",
            value: "",
          },
          {
            type: "select",
            field: "vehicleSeat",
            name: "座位数量",
            value: "",
            option: this.$const.SEATNUMBER,
          },
        ],
      },
      // 表头
      columns: [
        { prop: "vehiclePhoto", label: "车辆照片" },
        { prop: "licenseNo", label: "车辆号牌" },
        { prop: "vehicleNo", label: "车辆编号" },
        { prop: "vehicleModel", label: "车辆型号" },
        { prop: "vehicleColor", label: "车身颜色" },
        { prop: "vehicleSeat", label: "座位数量" },
        { prop: "vehicleResponsible", label: "车辆责任人" },
        { prop: "updated", label: "删除时间" },
        { prop: "operation", label: "操作" },
      ],
      detailShow: false,
      detailId: null
    };
  },
  methods: {
    /* 查看*/
    compileClick(row) {
      this.detailId = row.id;
      this.detailShow = true;
    },
  },
};
</script>

<style lang="less">
#vehicleBackup {
  .column-img {
    width: 32px;
    height: 32px;
  }

  .el-drawer {
    padding: 2%;
    width: 1250px !important;
    overflow: scroll;
  }
}
</style>
